import classNames from 'classnames';

import { rewriteImageSrc } from '@/utils/rewriteImageSrc';

import type { TTestimonialAttributes } from '../Testimonials.types';

interface Props {
  url: string;
  alt: string;
  className?: string;
  attributes: TTestimonialAttributes;
}

const ALIGNMENT_OPTIONS = {
  left: 'ml-0 mr-auto',
  center: 'mx-auto',
  right: 'ml-auto mr-0',
};

const Image = ({ url, alt, className, attributes }: Props) => {
  const alignment: keyof typeof ALIGNMENT_OPTIONS = attributes?.alignment || ('left' as any);
  const alignmentClass = ALIGNMENT_OPTIONS[alignment] || 'mx-0';

  const style = {
    width: attributes?.imageSize || '16px',
    height: attributes?.imageSize || '16px',
    borderRadius: attributes?.imageRadius || '100px',
  };

  return <img src={rewriteImageSrc(url)} alt={alt} className={classNames(alignmentClass, className)} style={style} />;
};

export default Image;
